import {Injectable} from '@angular/core';
import {GeneralService} from '../../../services/general.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Page} from '../../../model/page';
import {Observable} from 'rxjs/Observable';
import * as _ from 'lodash';

@Injectable()
export class MasterDataImportService extends GeneralService {

    static STATUS_REQUESTED = 10;
    static STATUS_PROCESSING = 20;
    static STATUS_COMPLETED = 30;
    static STATUS_FAILED = 40;

    constructor(
        protected http: HttpClient
    ) {
        super(http);
    }

    public getStatusOptions() {
        return [
            {value: MasterDataImportService.STATUS_REQUESTED, label: 'Requested'},
            {value: MasterDataImportService.STATUS_PROCESSING, label: 'Processing'},
            {value: MasterDataImportService.STATUS_COMPLETED, label: 'Completed'},
            {value: MasterDataImportService.STATUS_FAILED, label: 'Failed'}
        ];
    }

    public getItems(page: Page): Observable<any> {
        let params = new HttpParams();
        params = params.append('perPage', page.size.toString());
        params = params.append('page', (page.pageNumber).toString());
        if (!_.isUndefined(page.sortParams)) {
            for (const key of Object.keys(page.sortParams)) {
                const value = page.sortParams[key];
                params = params.append('sort[]', key + ',' + value );
            }
        }
        if (!_.isUndefined(page.filterParams)) {
            for (const key of Object.keys(page.filterParams)) {
                const value = page.filterParams[key];
                if (value && value !== '') {
                    params = params.append(key, value);
                }
            }
        }
        return this.http.get(this.apiUrl + '/master-data-import', { params : params });
    }
}


// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/oes/services/master-data-import.service.ts